module.exports = __webpack_public_path__ + "media/packs/images/flags/LU-fcda513d11a1cfccc87800a9892df479.png";